<template>
  <div class="sousuo-page">
    <div class="sousuo-page__hero">
      <div class="sousuo-page__hero-bg"></div>
      <div class="sousuo-page__hero-content">
        <h1 class="sousuo-page__hero-title">搜索音乐</h1>
        <p class="sousuo-page__hero-desc">发现您喜爱的歌曲、歌手、专辑和歌单</p>
        
        <div class="sousuo-page__search-box">
          <div class="sousuo-page__search-input-wrap">
            <svg class="sousuo-page__search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            <input 
              type="text" 
              class="sousuo-page__search-input" 
              v-model="searchKeyword" 
              placeholder="输入歌曲名、歌手名或歌词..."
            />
          </div>
        </div>

        <div class="sousuo-page__hot-searches">
          <span class="sousuo-page__hot-label">热门搜索</span>
          <div class="sousuo-page__hot-list">
            <a href="#" v-for="item in hotSearches" :key="item" @click.prevent="searchKeyword = item; handleSearch()" class="sousuo-page__hot-item">{{ item }}</a>
          </div>
        </div>
      </div>
    </div>

    <div class="sousuo-page__content">
      <div v-if="searchKeyword" class="sousuo-page__tabs">
        <button 
          v-for="tab in tabs" 
          :key="tab.id"
          class="sousuo-page__tab"
          :class="{ 'sousuo-page__tab--active': activeTab === tab.id }"
          @click="activeTab = tab.id"
        >
          <svg v-if="tab.icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <component :is="tab.icon" />
          </svg>
          {{ tab.name }}
          <span v-if="getTabCount(tab.id) > 0" class="sousuo-page__tab-count">{{ getTabCount(tab.id) }}</span>
        </button>
      </div>

      <div class="sousuo-page__results">
        <div v-if="!searchKeyword" class="sousuo-page__empty">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
          <p>找找你喜欢聆听的歌曲吧！</p>
        </div>

        <div v-else-if="isSearching" class="sousuo-page__loading">
          <div class="sousuo-page__loading-spinner"></div>
          <p>正在搜索...</p>
        </div>

        <div v-else class="sousuo-page__song-list">
          <div v-if="songs.length === 0" class="sousuo-page__no-results">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="15 9 9 15 9 9"></polyline>
            </svg>
            <p>暂无歌曲！</p>
          </div>
          <div v-for="(song, index) in songs" :key="song.id" class="sousuo-page__song-item" @click="goToDetail(song.id)">
            <div class="sousuo-page__song-index">{{ index + 1 }}</div>
            <div class="sousuo-page__song-cover">
              <img :src="song.image" :alt="song.music_name" />
              <div v-if="song.isnomf == 1" class="sousuo-page__song-vip">VIP</div>
              <div class="sousuo-page__song-play">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <polygon points="6 4 20 12 6 20 6 4"></polygon>
                </svg>
              </div>
            </div>
            <div class="sousuo-page__song-info">
              <h3 class="sousuo-page__song-name">{{ song.music_name }}</h3>
              <p class="sousuo-page__song-artist">{{ song.singer }}</p>
            </div>
            <div class="sousuo-page__song-album">{{ song.fenlei_name }}</div>
            <div class="sousuo-page__song-duration">{{ song.shichang }}</div>
            <!-- <button class="sousuo-page__song-action" @click.stop>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
              </svg>
            </button> -->
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'Sousuo',
  data() {
    return {
      searchKeyword: '',
      activeTab: 'songs',
      isSearching: false,
      tabs: [
        { id: 'songs', name: '单曲', icon: null }
      ],
      hotSearches: ['摄氏零度的拥抱', '重力消失的瞬间', '给失眠者的情书', '橘色公路', '万蝶之潮', '林间幅度'],
      songs: []
    }
  },
  watch: {
    searchKeyword(newVal) {
      if (!newVal.trim()) {
        this.songs = [];
        return;
      }
      this.isSearching = true;
      axios.get('https://xinyinyue.xiangyouhulian.cn/api/index/search', {
        params: {
          name: newVal.trim()
        }
      })
      .then(response => {
        this.songs = response.data.data || response.data || [];
      })
      .catch(error => {
        console.error('搜索失败:', error);
        this.songs = [];
      })
      .finally(() => {
        this.isSearching = false;
      });
    }
  },
  methods: {
    goToDetail(id) {
      this.$router.push({ name: 'xiangqing', params: { id } });
    },
    getTabCount(tabId) {
      return tabId === 'songs' ? this.songs.length : 0;
    }
  }
}
</script>

<style scoped lang="scss">
.sousuo-page {
  width: 100%;
  min-height: 100vh;
  position: relative;
  background-image: url('../../assets/gryh.jpg');
  background-size: cover;
  background-position: center center;
  background-attachment: fixed;
  background-repeat: no-repeat;
}

.sousuo-page__hero {
  position: relative;
  padding: 80px 20px 60px;
  overflow: hidden;
}

.sousuo-page__hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.sousuo-page__hero-content {
  position: relative;
  max-width:720px;
  margin: 0 auto;
  text-align: center;
}

.sousuo-page__hero-title {
  font-size: 42px;
  font-weight: 300;
  color: #ffffff;
  margin: 0 0 12px 0;
}

.sousuo-page__hero-desc {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0 0 30px 0;
}

.sousuo-page__search-box {
  display: flex;
  gap: 10px;
  max-width: 500px;
  margin: 0 auto 24px;
}

.sousuo-page__search-input-wrap {
  flex: 1;
  position: relative;
}

.sousuo-page__search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  color: rgba(255, 255, 255, 0.5);
}

.sousuo-page__search-input {
  width: 100%;
  height: 48px;
  padding: 0 14px 0 44px;
  border: none;
  border-radius: 24px;
  background-color: rgba(0, 0, 0, 0.3);
  color: #ffffff;
  font-size: 15px;
  box-sizing: border-box;
  outline: none;
  transition: all 0.2s;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
  
  &:focus {
    background-color: rgba(0, 0, 0, 0.4);
  }
}

.sousuo-page__search-btn {
  height: 48px;
  padding: 0 28px;
  border: none;
  border-radius: 24px;
  background-color: #f37021;
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background-color: #d95e12;
  }
}

.sousuo-page__hot-searches {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.sousuo-page__hot-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
}

.sousuo-page__hot-list {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.sousuo-page__hot-item {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
  padding: 4px 12px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  transition: all 0.2s;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
    color: #ffffff;
  }
}

.sousuo-page__content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 20px;
  min-height: calc(100vh - 300px);
}

.sousuo-page__tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
}

.sousuo-page__tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  border: none;
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  
  svg {
    width: 16px;
    height: 16px;
  }
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    color: #ffffff;
  }
  
  &--active {
    background-color: #f37021;
    color: #ffffff;
  }
}

.sousuo-page__tab-count {
  font-size: 12px;
  background-color: rgba(255, 255, 255, 0.2);
  padding: 1px 6px;
  border-radius: 10px;
}

.sousuo-page__results {
  min-height: 300px;
}

.sousuo-page__empty,
.sousuo-page__no-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  color: rgba(255, 255, 255, 0.4);
  
  svg {
    width: 64px;
    height: 64px;
    margin-bottom: 16px;
  }
  
  p {
    font-size: 15px;
    margin: 0;
  }
}

.sousuo-page__loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  color: rgba(255, 255, 255, 0.6);
  
  p {
    font-size: 14px;
    margin: 16px 0 0;
  }
}

.sousuo-page__loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.1);
  border-top-color: #f37021;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.sousuo-page__song-list {
  background-color: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  overflow: hidden;
}

.sousuo-page__song-item {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  transition: background-color 0.2s;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
    
    .sousuo-page__song-play {
      opacity: 1;
    }
    
    .sousuo-page__song-index {
      color: #f37021;
    }
  }
  
  &:last-child {
    border-bottom: none;
  }
}

.sousuo-page__song-index {
  width: 30px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
  text-align: center;
  flex-shrink: 0;
}

.sousuo-page__song-cover {
  width: 44px;
  height: 44px;
  margin-right: 14px;
  position: relative;
  flex-shrink: 0;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
  }
}

.sousuo-page__song-vip {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #f37021;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 2px 0 2px 0;
  z-index: 3;
}

.sousuo-page__song-play {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
  border-radius: 4px;
  
  svg {
    width: 18px;
    height: 18px;
    color: #ffffff;
    margin-left: 2px;
  }
}

.sousuo-page__song-info {
  flex: 1;
  min-width: 0;
  
  h3 {
    font-size: 14px;
    color: #ffffff;
    margin: 0 0 4px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  p {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
    margin: 0;
  }
}

.sousuo-page__song-album {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);
  min-width: 100px;
  margin-right: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sousuo-page__song-duration {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
  margin-right: 16px;
  flex-shrink: 0;
}

.sousuo-page__song-action {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: all 0.2s;
  
  svg {
    width: 18px;
    height: 18px;
  }
  
  &:hover {
    color: #f37021;
    background-color: rgba(243, 112, 33, 0.1);
  }
}



@media (max-width: 768px) {
  .sousuo-page__hero-title {
    font-size: 32px;
  }
  
  .sousuo-page__song-item {
    padding: 10px 16px;
  }
  
  .sousuo-page__song-album {
    display: none;
  }
}
</style>